module.exports = __webpack_public_path__ + "static/media/support-station-main-img.025d0d13.jpg";